
[
  {
    "id": "TIJD-PAT-L3-001",
    "module": "TijdGeld",
    "difficulty": 201,
    "question": "Kijk naar de rij: 1 - 1 - 2 - 3 - 5 - 8 - ... Welk getal komt daarna?",
    "options": ["13", "11", "10", "16"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "grafieken",
    "subSkill": "patronen",
    "familyId": "TIJD-PAT-FIBONACCI",
    "explanation": "Dit is de Fibonacci-reeks! Elk getal is de som van de twee vorige: 5 + 8 = 13.",
    "distractorExplanations": {
      "1": "Je deed +3. Maar kijk naar het patroon: 1+1=2, 1+2=3, 2+3=5, 3+5=8, 5+8=13.",
      "2": "Je deed +2. Maar de sprongen worden steeds groter!",
      "3": "Je deed ×2. Maar dit is een optelling van de twee vorige getallen."
    }
  },
  {
    "id": "TIJD-PAT-L3-002",
    "module": "TijdGeld",
    "difficulty": 201,
    "question": "Welk getal past in de rij: 100 - 90 - 81 - 73 - ... - 60?",
    "options": ["66", "67", "65", "68"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "grafieken",
    "subSkill": "patronen",
    "familyId": "TIJD-PAT-COMPLEX",
    "explanation": "De sprongen worden steeds 1 kleiner: -10, -9, -8, -7, -6. Dus 73 - 7 = 66.",
    "distractorExplanations": {
      "1": "Je deed -6. Maar de sprong na -7 is -6, niet de sprong na 73!",
      "2": "Je deed -8. Maar de sprongen worden kleiner, niet groter!",
      "3": "Je deed -5. Maar kijk: 100-90=10, 90-81=9, 81-73=8, dus 73-?=7."
    }
  },
  {
    "id": "TIJD-TAB-L3-003",
    "module": "TijdGeld",
    "difficulty": 201,
    "question": "Cijfers: Toets 1: 7, Toets 2: 8, Toets 3: 6. Wat is het gemiddelde cijfer?",
    "options": ["7,0", "7,5", "6,5", "8,0"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "grafieken",
    "subSkill": "tabellen_lezen",
    "familyId": "TIJD-TAB-GEMIDDELDE",
    "explanation": "Tel alle cijfers op: 7 + 8 + 6 = 21. Deel door 3 toetsen: 21 ÷ 3 = 7,0.",
    "distractorExplanations": {
      "1": "Je hebt verkeerd gedeeld. 21 ÷ 3 = 7,0, niet 7,5.",
      "2": "Je hebt verkeerd gedeeld. 21 ÷ 3 = 7,0, niet 6,5.",
      "3": "Je hebt niet gedeeld. Het gemiddelde is de som gedeeld door het aantal."
    }
  },
  {
    "id": "TIJD-DUR-L3-001",
    "module": "TijdGeld",
    "difficulty": 201,
    "question": "Een concert begint om 19:45 en duurt 2 uur en 35 minuten. Hoe laat is het afgelopen?",
    "options": ["22:20", "22:10", "21:20", "22:30"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tijdrekenen",
    "subSkill": "tijdsduur_berekenen",
    "familyId": "TIJD-DUR-MEERDERE",
    "explanation": "19:45 + 2 uur = 21:45. Dan + 35 minuten = 22:20.",
    "distractorExplanations": {
      "1": "Je bent 10 minuten vergeten. 45 + 35 = 80 minuten = 1 uur en 20 minuten.",
      "2": "Je bent maar 1 uur en 35 minuten verder gegaan.",
      "3": "Je hebt 10 minuten te veel geteld."
    }
  },
  {
    "id": "TIJD-DUR-L3-002",
    "module": "TijdGeld",
    "difficulty": 201,
    "question": "De les eindigt om 11:30. De les duurde 1 uur en 45 minuten. Hoe laat begon de les?",
    "options": ["09:45", "10:15", "09:30", "10:00"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tijdrekenen",
    "subSkill": "tijdsduur_berekenen",
    "familyId": "TIJD-DUR-TERUGREKENEN",
    "explanation": "11:30 - 1 uur = 10:30. Dan - 45 minuten = 09:45.",
    "distractorExplanations": {
      "1": "Je bent maar 1 uur en 15 minuten teruggegaan.",
      "2": "Je bent 15 minuten te weinig teruggegaan.",
      "3": "Je bent maar 1 uur en 30 minuten teruggegaan."
    }
  },
  {
    "id": "GELD-PRIJS-L3-001",
    "module": "TijdGeld",
    "difficulty": 201,
    "question": "Actie: 3 halen, 2 betalen. Normaal € 4,50 per stuk. Hoeveel bespaar je als je 3 stuks koopt?",
    "options": ["€ 4,50", "€ 9,00", "€ 3,00", "€ 13,50"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "geld_rekenen",
    "subSkill": "korting",
    "familyId": "GELD-PRIJS-COMPLEX-1",
    "explanation": "3 halen, 2 betalen. Normaal: 3 × €4,50 = €13,50. Nu: 2 × €4,50 = €9,00. Besparing: €13,50 - €9,00 = €4,50.",
    "distractorExplanations": {
      "1": "Je bespaart 1 stuk, niet 2. 1 × €4,50 = €4,50.",
      "2": "Je betaalt €9,00, maar je bespaart €4,50.",
      "3": "€13,50 is wat je normaal zou betalen, niet wat je bespaart."
    }
  },
  {
    "id": "GELD-PRIJS-L3-002",
    "module": "TijdGeld",
    "difficulty": 201,
    "question": "Winkel A: 25% korting op € 40. Winkel B: vaste prijs € 28. Waar is het goedkoper?",
    "options": ["Winkel B", "Winkel A", "Even duur", "Winkel A en B"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "geld_rekenen",
    "subSkill": "korting",
    "familyId": "GELD-PRIJS-COMPLEX-2",
    "explanation": "Winkel A: 25% korting op €40 = €40 - €10 = €30. Winkel B: €28. €28 < €30, dus Winkel B is goedkoper.",
    "distractorExplanations": {
      "1": "Winkel A kost €30 na korting. Winkel B kost €28. Winkel B is goedkoper!",
      "2": "De prijzen zijn niet gelijk: €30 ≠ €28.",
      "3": "Je moet kiezen: Winkel B is goedkoper."
    }
  },
  {
    "id": "GELD-BOOD-L3-001",
    "module": "TijdGeld",
    "difficulty": 201,
    "question": "Je koopt: 2 broden à € 2,35, 3 pakken melk à € 1,15, en kaas voor € 4,80. Wat is het totaal?",
    "options": ["€ 13,15", "€ 12,15", "€ 14,15", "€ 13,50"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "geld_rekenen",
    "subSkill": "boodschappen",
    "familyId": "GELD-BOOD-COMPLEX-1",
    "explanation": "2 broden × €2,35 = €4,70. 3 pakken melk × €1,15 = €3,45. Kaas €4,80. Totaal: €4,70 + €3,45 + €4,80 = €13,15.",
    "distractorExplanations": {
      "1": "Je bent €1 vergeten. Check: €4,70 + €3,45 + €4,80 = €13,15.",
      "2": "Je hebt €1 te veel. Check: €4,70 + €3,45 + €4,80 = €13,15.",
      "3": "Je hebt 35 cent te veel. Check: €4,70 + €3,45 + €4,80 = €13,15."
    }
  },
  {
    "id": "GELD-SPAAR-L3-001",
    "module": "TijdGeld",
    "difficulty": 201,
    "question": "Je wilt een fiets van € 180,00. Je hebt € 75,00 en spaart € 15,00 per maand. Na hoeveel maanden kun je de fiets kopen?",
    "options": ["7 maanden", "6 maanden", "8 maanden", "12 maanden"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "geld_rekenen",
    "subSkill": "sparen",
    "familyId": "GELD-SPAAR-COMPLEX-1",
    "explanation": "Fiets kost €180. Je hebt €75. Je moet nog €180 - €75 = €105 sparen. €105 ÷ €15 = 7 maanden.",
    "distractorExplanations": {
      "1": "Na 6 maanden heb je €75 + €90 = €165. Je komt €15 tekort!",
      "2": "Na 8 maanden heb je €75 + €120 = €195. Je hebt maar 7 maanden nodig.",
      "3": "Na 12 maanden heb je €75 + €180 = €255. Je hebt maar 7 maanden nodig."
    }
  },
  {
    "id": "TIJD-L4-001",
    "module": "TijdGeld",
    "difficulty": 201,
    "question": "De trein vertrekt om 14:20. De reis duurt 1 uur en 35 minuten. Je stopt 10 minuten voor een pauze. Hoe laat kom je aan?",
    "options": ["15:55", "16:05", "16:15", "15:45"],
    "correctAnswer": 1,
    "questionType": "multiple_choice",
    "skill": "tijdrekenen",
    "subSkill": "tijdsduur_berekenen",
    "familyId": "TIJD-REIS-PAUZE"
  }
]
